import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { formatLabel } from '../../constants/assetDetailMetadata';
import { formatMetadataDisplayValue } from '../../contracts/openapi/assetDisplayFormatters';

interface ReadOnlyMetadataGridProps {
  data: Record<string, unknown> | null | undefined;
  allKeys?: string[];
}

export default function ReadOnlyMetadataGrid({
  data,
  allKeys,
}: ReadOnlyMetadataGridProps) {
  if (!data && !allKeys?.length) {
    return null;
  }

  const keys = allKeys ?? (data ? Object.keys(data) : []);
  if (keys.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        gap: 1.5,
      }}
    >
      {keys.map((key) => {
        const displayValue = formatMetadataDisplayValue(key, data?.[key]);

        return (
          <Box
            key={key}
            sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'baseline' }}
          >
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600 }}>
              {formatLabel(key)}:
            </Typography>
            {displayValue === null ? (
              <Typography variant="body2" color="text.secondary">
                —
              </Typography>
            ) : Array.isArray(displayValue) ? (
              <Stack direction="row" flexWrap="wrap" gap={0.5}>
                {displayValue.map((item, index) => (
                  <Chip key={`${key}-${index}`} label={item} size="small" variant="outlined" />
                ))}
              </Stack>
            ) : typeof displayValue === 'boolean' ? (
              <Typography variant="body2">{displayValue ? 'Yes' : 'No'}</Typography>
            ) : (
              <Typography variant="body2">{displayValue}</Typography>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
